<template>
  <span>{{label || defaultValue}}</span>
</template>
<script>
export default {
  props: {
    category: {
      required: true
    },
    value: {
      required: false,
      default: ''
    },
    defaultValue: {
       required: false,
      default: ''
    }
  },
  data () {
    return {
      label: ''
    }
  },
  watch: {
    value: {
      handler (newValue, oldValue) {
        if (newValue != oldValue)
          this.getLabel()
      },

      immediate: true,
    },

  },
  methods: {
    getLabel: function () {
      console.log(this.category, this.value)
      this.getDicLabel(this.value, this.category).then(val => {
        this.label = val
      })
    }
  }
}
</script>